import {
    Box,
} from '@mui/material';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";


interface BlankBlockProps {
    blockHeight: number,
    startHour: number,
    endHour: number,
    key: string,
    onClick: (block: any) => void,
}

const BlankBlock: React.FC<BlankBlockProps> = ({
    blockHeight,
    startHour,
    endHour,
    key,
    onClick,
}) => {
    return (
    <Box
        key={key}
        onClick={onClick}
        sx={{
            position: 'absolute',
            top: `${startHour * blockHeight}px`,
            height: `${(endHour - startHour) * blockHeight}px`,
            left: 0,
            right: 0,
            zIndex: 1,
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '1%',
            width: '100%',
            cursor: 'pointer',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background 0.2s, border-color 0.2s",
            "&:hover": {
                backgroundColor: "rgba(173, 216, 230, 0.5)",
            },
        }} >
            <AddCircleOutlineIcon sx={{ color: "black", fontSize: 50 }} />
    </Box>
          );
}

export default BlankBlock;
